import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import {
  getAvailableLists,
  addToList,
  removeFromList,
  isInList
} from '../utils/contentService';
import SelectListaCustom from '../components/SelectListaCustom';

interface ContentModalProps {
  item: {
    id: string;
    title: string;
    description: string;
    imageSrc?: string;
    videoSrc?: string;
    embedId?: string;
  };
  onClose: () => void;
}

const ContentModal: React.FC<ContentModalProps> = ({ item, onClose }) => {
  const { toast } = useToast();
  const [listasDisponiveis, setListasDisponiveis] = useState<string[]>([]);
  const [listaSelecionada, setListaSelecionada] = useState<string>('Meus Favoritos');
  const [itemNaLista, setItemNaLista] = useState(false);

  // Carrega as listas disponíveis
  const atualizarListas = () => {
    const listas = getAvailableLists();
    setListasDisponiveis(listas);
  };

  // Atualiza status do item na lista
  const verificarItemNaLista = () => {
    const presente = isInList(listaSelecionada, item.id);
    setItemNaLista(presente);
  };

  useEffect(() => {
    atualizarListas();
  }, []);

  useEffect(() => {
    verificarItemNaLista();
  }, [listaSelecionada]);

  const handleToggleLista = () => {
    if (itemNaLista) {
      removeFromList(listaSelecionada, item.id);
      toast({ title: 'Removido da lista com sucesso' });
    } else {
      addToList(listaSelecionada, item);
      toast({ title: 'Adicionado à lista com sucesso' });
    }
    verificarItemNaLista();
    atualizarListas();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="relative w-full max-w-2xl p-6 bg-zinc-900 rounded-lg shadow-lg">
        <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-red-500">
          <X size={24} />
        </button>

        <h2 className="text-2xl font-bold text-white mb-4">{item.title}</h2>

        {item.videoSrc ? (
          <video controls className="w-full mb-4 rounded">
            <source src={item.videoSrc} type="video/mp4" />
          </video>
        ) : item.embedId ? (
          <iframe
            className="w-full h-64 mb-4 rounded"
            src={`https://www.youtube.com/embed/${item.embedId}`}
            frameBorder="0"
            allowFullScreen
          />
        ) : null}

        <p className="text-zinc-300 mb-4">{item.description}</p>

        <div className="flex flex-col sm:flex-row items-center gap-4 p-4 rounded bg-zinc-800">
          <SelectListaCustom
            listas={listasDisponiveis}
            selecionada={listaSelecionada}
            onChange={setListaSelecionada}
            onListasAtualizadas={atualizarListas}
          />
          <button
            onClick={handleToggleLista}
            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
          >
            {itemNaLista ? 'Remover da Lista' : 'Adicionar à Lista'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentModal;
